const HelpTicketEdit = () => import("./views/HelpTicketEdit.vue");

const route = "/helpTickets";

export default [
  {
    path: `${route}/create`,
    name: "helpTickets.create",
    component: HelpTicketEdit,

    meta: {
      roles: [
        "ROLE_ADMIN",
        "ROLE_INSTITUTIONS_ADMIN",
        "ROLE_PARENT",
        "ROLE_INSTITUTION_WORKER",
        "ROLE_COOK",
      ],
    },
  },
];
